// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__uy4ge","spinner":"Loader_spinner__jZedo","spin":"Loader_spin__L7yww"};